export const REGISTRATION_METHOD_SELF_CUSTODY = 'selfCustody'
export const REGISTRATION_METHOD_TORUS = 'torus'
